import { render, staticRenderFns } from "./CourseShowBuy.vue?vue&type=template&id=3187548a&scoped=true&"
import script from "./CourseShowBuy.vue?vue&type=script&lang=js&"
export * from "./CourseShowBuy.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowBuy.vue?vue&type=style&index=0&id=3187548a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187548a",
  null
  
)

export default component.exports